import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEmploymentDurationPage = {
  alert: {
    error: 'coapplicant-employment-duration.form.alert.error',
  },
  footer: {
    root: 'coapplicant-employment-duration.footer.root',
  },
  form: {
    h1: 'coapplicant-employment-duration.form.h1',
    h2: 'coapplicant-employment-duration.form.h2',
    radioGroupRoot: 'coapplicant-employment-duration.form.radio-group-root',
    radioOption1: 'coapplicant-employment-duration.form.radio-option1',
    radioOption2: 'coapplicant-employment-duration.form.radio-option2',
    root: 'coapplicant-employment-duration.form.root',
    submitButton: 'coapplicant-employment-duration.form.submit-button',
  },
  header: {
    drawerButton: 'coapplicant-employment-duration.header.drawer-button',
    previousStepButton:
      'coapplicant-employment-duration.header.previous-step-button',
    root: 'coapplicant-employment-duration.header.root',
  },
  progress: {
    root: 'coapplicant-employment-duration.progress.root',
  },
} as const satisfies PageLocatorMap;
